'use client';
/** @jsxImportSource @emotion/react */

import type { ImageListProps } from '@mui/material/ImageList';

import MuiImageList from '@mui/material/ImageList';

export type { ImageListProps };
export const ImageList = MuiImageList;
